import { stat } from "fs";


export default {
    state: {
        food: []
    },
    mutations: {
        addFood(state, payload) {
            let food = state.food;
            food.push(payload);
            state.food = food;
        },
        setFood(state, payload) {
            state.food = payload;
        },
        updateFood(state, payload) {
            let food = state.food;            
            const newFood = food.map(food => {
                console.log('>>',food.id, payload.id);
                if (food.id === payload.id){
                    console.log('before',payload);
                    return payload;
                }
                return food;
            });
            console.log('after',payload);
            // let foodItem = food.find(food => food.id == payload.id);
            // foodItem = payload; // Update the state
            //console.log('State', newFood,payload)
            state.food = newFood;
        },
        deleteFood(state, payload) {
            let food = state.food;
            let filteredFood = food.filter(food => food.id != payload.id);
            state.food = filteredFood;
        }
    },
    actions: {

    },
    getters: {
        allFood(state) {
            console.log('Loading all food');
            return state.food;
        }
    }
}